import "./App.css";
import React from "react";
import AppRoutes from "./routes"; // Importation des routes de l'application

function App() {
  return (
    <div className="App">
      <AppRoutes />{" "}
    </div>
  );
}

export default App;
